
export const backendserverurl = 'https://echnewsaas-9242363bk-01.pitech.co.ug'
// Add any other JavaScript code here
                    
//http://127.0.0.1:8000/

//http://104.131.54.129:10225


//UMI https://sasacco-5111608bk-01.pitech.co.ug
//demo  echnewsaas-9242363bk-01.pitech.co.ug	
//